import React, { useEffect, useRef } from "react";
import { resolveMediaUrl } from "./PageContent";

// Renders a YouTube embed by video ID, Instagram blockquote via embed.js,
// HTML5 video, or image. Pipes through resolveMediaUrl so /api/uploads/ URLs
// get the backend prefix AND res.cloudinary.com URLs pick up q_auto,f_auto.
export const MediaEmbed = ({ item, className = "" }) => {
  const igRef = useRef(null);

  useEffect(() => {
    if (item?.media_type !== "instagram") return;
    const SRC = "https://www.instagram.com/embed.js";
    const existing = document.querySelector(`script[src="${SRC}"]`);
    if (!existing) {
      const s = document.createElement("script");
      s.async = true;
      s.src = SRC;
      document.body.appendChild(s);
    } else if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
    // Try processing after a tick in case the script is already loaded
    const t = setTimeout(() => {
      if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
    }, 350);
    return () => clearTimeout(t);
  }, [item?.media_type, item?.media_url]);

  if (!item) return null;

  if (item.media_type === "youtube") {
    return (
      <div className={`relative w-full h-full bg-asphalt ${className}`}>
        <iframe
          src={`https://www.youtube.com/embed/${item.media_url}?rel=0&modestbranding=1`}
          title={item.caption || "YouTube clip"}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  if (item.media_type === "instagram") {
    return (
      <div
        className={`relative w-full h-full overflow-auto bg-bone ${className}`}
        data-testid="instagram-embed"
      >
        <blockquote
          ref={igRef}
          className="instagram-media"
          data-instgrm-captioned
          data-instgrm-permalink={item.media_url}
          data-instgrm-version="14"
          style={{
            background: "#FFF",
            border: 0,
            margin: 0,
            maxWidth: "100%",
            minWidth: 0,
            padding: 0,
            width: "100%",
          }}
        >
          <a href={item.media_url} target="_blank" rel="noreferrer" className="block p-4 font-mono text-xs uppercase tracking-[0.25em] text-asphalt">
            View this post on Instagram →
          </a>
        </blockquote>
      </div>
    );
  }

  if (item.media_type === "video") {
    return (
      <video
        className={`w-full h-full object-cover ink-stamp ${className}`}
        src={resolveMediaUrl(item.media_url)}
        poster={resolveMediaUrl(item.thumbnail)}
        loop
        muted
        playsInline
        autoPlay
      />
    );
  }

  // image
  return (
    <img
      src={resolveMediaUrl(item.media_url)}
      alt={item.caption || "Evidence"}
      className={`w-full h-full object-cover ink-stamp ${className}`}
      loading="lazy"
    />
  );
};
